import axiosInstance from "@/plugins/HTTP";
import authHeader from "./auth-header";

class AuthService {
  //Layer
  login(user) {
    return axiosInstance
      .post("login", {
        login: user.username,
        password: user.password
      }, {
        headers: authHeader(true),
      })
      .then((response) => {
        if (!response.data.authenticated) throw Object.assign(new Error(response.data.message || 'Sign-in failed'), { response });
        localStorage.setItem("user", JSON.stringify({ authenticated: true }));
        return response;
      });
  }

  logout() { return axiosInstance.post('logout'); }

  getPanelSetting() {
    return axiosInstance.get("panel-setting", {
      headers: authHeader(true)
    });
  }

  getProfile() {
    return axiosInstance.get("user-profile", {
      headers: authHeader()
    }).then(response => {
      if (!response.data.success || !response.data.result?.user) throw Object.assign(new Error(response.data.message || 'Your session has expired'), { response });
      return response;
    });
  }
}

export default new AuthService();
